import React from 'react';
import StepWizard from 'react-step-wizard';
import Navbar, { INavbarIconProps } from './Navbar/Navbar';
import Item, { IItemProps } from './Item';
interface IWizardProps {
  requestData: Object;
  children: React.ReactElement<IItemProps>[];
  onSubmit: () => void;
  onCancel: () => void;
  navIcons?: INavbarIconProps;
}

const Wizard = (props: IWizardProps) => {
  const wizardContext = props.requestData;

  const navSteps = props.children.map((item) => {
    return {
      title: item.props.title,
      description: item.props.description,
      iconRoot: item.props.iconRoot,
      icon: item.props.icon
    };
  });

  const onSubmit = () => {
    props.onSubmit();
  };

  return (
    <div className="report-container">
      {wizardContext && (
        <StepWizard
          isLazyMount={true}
          transitions={{}}
          nav={
            <Navbar navIcons={props.navIcons} navSteps={navSteps} {...this} />
          }
        >
          {props.children.map((Step: React.ReactElement, index: number) =>
            React.cloneElement(<Step.props.component />, {
              wizardContext,
              onSubmit,
              key: index + Step.props.title.split(' ').join(''),
              onCancel: props.onCancel
            })
          )}
        </StepWizard>
      )}
    </div>
  );
};

Wizard.Item = Item;
export default Wizard;
